import { render, staticRenderFns } from "./vf-button.vue?vue&type=template&id=ffdb8660&scoped=true"
import script from "./vf-button.vue?vue&type=script&lang=js"
export * from "./vf-button.vue?vue&type=script&lang=js"
import style0 from "./vf-button.vue?vue&type=style&index=0&id=ffdb8660&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffdb8660",
  null
  
)

export default component.exports